import React from "react";
// import ClassNames from 'classnames'

let STEPS = [
  {
    word: "Rip",
    img: "/images/home/using-step1.png"
  },
  {
    word: "Drop",
    img: "/images/home/using-step2.png"
  },
  {
    word: "Go",
    img: "/images/home/using-step3.png"
  }
];

class Intro extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="Using">
        <div className="internal">
          <h2>Get Your Yoga Warm-Up Ready in 30 Seconds </h2>
          <div className="steps">
            {STEPS.map((step, i) => {
              return (
                <div className="step" key={i}>
                  <div className="image">
                    <span className="number">{i + 1}</span>
                    <img src={step.img} />
                  </div>
                  <span className="word">{step.word}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default Intro;



// WEBPACK FOOTER //
// ./src/home/using.js